// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import RejectReturnApproveButtons from './reject-return-approve-buttons';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../../shared/services/security';

const SecureRejectReturnApproveButtons = (props, context) => hasAccess(context.security, props.securityModule, props.securityFeature) &&
    <RejectReturnApproveButtons
        onApprove={props.onApprove}
        onReject={props.onReject}
        onReturn={props.onReturn}
    />;

SecureRejectReturnApproveButtons.displayName = 'SecureRejectReturnApproveButtons';
SecureRejectReturnApproveButtons.propTypes = {
    onApprove: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    onReturn: PropTypes.func.isRequired,
    securityFeature: PropTypes.string,
    securityModule: PropTypes.string.isRequired

};
SecureRejectReturnApproveButtons.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default SecureRejectReturnApproveButtons;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/secure-reject-return-approve-buttons.js